import { HelperCore } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';

class DsEnhanceStore {
  isFolded = false;     // 是否折叠
  is_so = true;
  get supportFold () {
    return true;
  }

  constructor () {
    makeAutoObservable(this);
  }

  /**
   * 输入变化
   */
  updateData (data) {
    Object.keys(data).forEach(key => {
      let inputData = HelperCore.copyObj(data[key]);

      switch(key){
        case "type":{
          // 追问不支持收起
          if(data[key] != "flow"){
            this.isFolded = false;
          }
          break;
        }
      }

      this[key] = inputData;
    });
  }

  setFolded (isFolded) {
    this.isFolded = isFolded;
  }
  toggleFolded = () => {
    this.setFolded(!this.isFolded);
  }
}


export default DsEnhanceStore;